import { render, staticRenderFns } from "./vsPaginationLengthCustom.vue?vue&type=template&id=4e75245f"
import script from "./vsPaginationLengthCustom.vue?vue&type=script&lang=js"
export * from "./vsPaginationLengthCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e75245f')) {
      api.createRecord('4e75245f', component.options)
    } else {
      api.reload('4e75245f', component.options)
    }
    module.hot.accept("./vsPaginationLengthCustom.vue?vue&type=template&id=4e75245f", function () {
      api.rerender('4e75245f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsPaginationLengthCustom/vsPaginationLengthCustom.vue"
export default component.exports